import { Transport, TransportFilters } from '../../../../app/models/Transport';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import { momentParseDate } from '../../../../helpers';

interface Props {
    transports: Transport[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: TransportFilters;
    setFilter: (filter: TransportFilters) => void;
    callbackSuccess: () => void;
    onSearch: () => void;
}

const TransportDataTable = ({
    transports,
    totalRows,
    loading = false,
    edit,
    destroy,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: any) => row.id || 0,
            sortable: true,
            sortField: 'id',
            width: '80px',
            cell: (row: Transport) => <span>{row.id || '-'}</span>
        },
        {
            name: 'Vehículo',
            selector: (row: any) => row.vehicle_patent || 'Sin vehículo',
            sortable: false,
            cell: (row: Transport) => (
                <span>
                    {row.vehicle_patent || 'Sin vehículo'}
                    {row.vehicle_type && ` (${row.vehicle_type})`}
                </span>
            )
        },
        {
            name: 'Fecha de Despacho',
            selector: (row: any) => row.dispatch_date || '',
            sortable: true,
            sortField: 'dispatch_date',
            width: '150px',
            cell: (row: Transport) => (
                <span>{row.dispatch_date ? momentParseDate(row.dispatch_date) : '-'}</span>
            )
        },
        {
            name: 'Estado',
            selector: (row: any) => row.status_label ?? row.status ?? '',
            sortable: true,
            sortField: 'status',
            width: '120px',
            cell: (row: Transport) => (
                <span>{row.status_label ?? row.status ?? '-'}</span>
            )
        },
        {
            name: 'Nodos',
            selector: (row: any) => row.nodes_count || 0,
            sortable: false,
            width: '100px',
            cell: (row: Transport) => <span>{row.nodes_count || 0}</span>
        },
        {
            name: 'Entregas',
            selector: (row: any) => row.deliveries_count || 0,
            sortable: false,
            width: '100px',
            cell: (row: Transport) => <span>{row.deliveries_count || 0}</span>
        },
        {
            name: 'Acciones',
            selector: (row: any) => row?.id,
            sortable: false,
            width: '150px',
            cell: (row: Transport) => {
                const transportId = row?.id && row.id > 0 ? row.id : null;
                if (!transportId) return null;
                
                return (
                    <div className="">
                        {edit && (
                            <ButtonTableAction
                                callbackFunction={() => edit(transportId)}
                                classIcon={'mdi mdi-pencil'}
                                colorIcon={'text-warning'}
                                errorMessage={'No se puede editar este registro.'}
                                title={'Editar'}
                            />
                        )}
                        {destroy && (
                            <ButtonTableAction
                                callbackFunction={() => destroy(transportId)}
                                classIcon={'mdi mdi-delete'}
                                colorIcon={'text-danger'}
                                errorMessage={'No se puede eliminar este registro.'}
                                title={'Eliminar'}
                            />
                        )}
                    </div>
                );
            }
        }
    ];

    return (
        <>
            <DefaultDataTable
                columns={columns}
                data={transports}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default TransportDataTable;
